<div class="progress-tracker flexbox-column gap-24">
    <div class="header flexbox-column gap-10">
        <span class="d-flex justify-content-between align-items-center">
            <span class="d-flex align-items-center gap-8">
                <i class="fa-regular fa-circle-play fs-20"></i>
                <h5 class="text-sm font-semibold">Getting Started</h5>
            </span>
            
            <p class="text-xs text-gray-500 fw-bold">{{ completedSteps() }}/{{ totalSteps() }}</p>
        </span>
    </div>

    <div class="steps">
        @for (step of steps; track step.id; let i = $index) {
        <div class="step d-flex gap-12 align-items-center">
            <div class="check-circle">
                @if((i + 1) < currentStep()) {
                <i class="fa-solid fa-circle-check text-success fs-18 mt-1"></i>
                } @else {
                <i class="fa-solid fa-circle-check text-gray-3 fs-18 mt-1"></i>
                }
            </div>
            <div class="step-details flexbox-column gap-6">
                @if((i + 1) < currentStep()) {
                <a class="step-title item-title fw-bold" [routerLink]="[step.route]">{{ step.title }}</a>
                } @else {
                <p class="step-title item-title fw-bold inactive-step">{{ step.title }}</p>
                }
                
            </div>  
        </div>
        }
    </div>

    <button mat-button mat-flat-button color="primary" class="button-default" (click)="navigateToOnboarding()">Complete Now</button>
</div>
